import styled from "styled-components";
import {
  List,
  ListItem,
  Button,
  CircularProgress,
  IconButton,
} from "@material-ui/core";
import { Close } from "@material-ui/icons";
import bgChat from "../../../assets/images/bg-chat.png";
import { BiTime } from "react-icons/bi";

export const CircularLoading = styled(CircularProgress)`
  position: absolute;
  left: 50%;
  top: 10%;
  background: #fff;
  padding: 4px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
`;

export const Footer = styled.div`
  margin-top: 3px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const ContainerList = styled(List)`
  height: 100%;
  overflow: auto;
  box-sizing: border-box;
  background: #fefefe;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 0px 0px 0px 10px;
  padding: 0px;
  margin: 0px;
  transition: 0.3s;
  background-image: url(${bgChat});

  ${(props) =>
    props.$upMessage &&
    `
    padding-bottom:65px;
    transition:0.4s;
  `}

  .MuiListItem-root {
    padding: 0px;
  }

  .customer {
    display: flex;
    justify-content: flex-start;

    div {
      background-color: #fff;
    }
  }

  .user {
    display: flex;
    justify-content: flex-end;

    div {
      background-color: #dcf8c6;
    }
  }

  .not_found.user {
    div {
      background-color: #fa8072;
    }
  }

  .system,
  .loading {
    display: flex;
    justify-content: center;
    text-align: center;

    div {
      background-color: #dcdeeb;
    }

    margin-top: 15px;
    margin-bottom: 15px;
  }

  img.tall {
    max-height: 250px;
    max-width: 100%;
    width: auto;
  }

  .highlight {
    filter: brightness(0.8) saturate(1.1);
  }
`;

export const Item = styled(ListItem)`
  display: flex;

  &:last-child {
    margin-bottom: 5px;
  }
`;

export const ContainerMessages = styled.div`
  width: 50%;
  background: transparent !important;
  display: flex;
  justify-content: ${(props) =>
    props.sides !== "user" ? "flex-start" : "flex-end"};
`;

export const MessageLoading = styled(CircularProgress)``;

export const Message = styled.div`
  margin: 0px 10px 5px 10px;
  width: ${(props) =>
    props?.size === null || props?.size === "application/pdf"
      ? "100%"
      : "auto"};
  max-width: 50em;
  box-shadow: 0 0 1em #c9c9c9;
  padding: 10px;
  border-radius: 10px;
  overflow: hidden;
`;

export const Text = styled.div`
  overflow-wrap: break-word;

  a {
    margin-right: 4px;
  }
`;

export const Audio = styled.audio`
  max-width: 400px;
`;

export const Figure = styled.div`
  width: 100%;
  height: ${({ height, width }) =>
    height < 100 || width > 2000 ? `150px` : "340px"};
  margin-top: 4px;
  cursor: pointer;
  border-radius: 6px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  overflow: hidden;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: ${({ height, width }) =>
    height < 100 || width > 2000 ? `cover` : "fill"};
`;

export const Video = styled.video`
  max-width: 400px;
  max-height: 400px;
`;

export const MessageDate = styled.p`
  text-align: right;
  font-size: 8px;
  vertical-align: initial;
  outline: none;

  height: 15px;
  font-size: 11px;
  line-height: 15px;
  color: rgba(0, 0, 0, 0.45);
  white-space: nowrap;
`;

export const Header = styled.div`
  width: 100%;
  height: 8px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;

  svg {
    cursor: pointer;
  }
`;

export const MessageHeaderContainer = styled.div`
  .replied-message {
    cursor: pointer;
    opacity: 0.5;
  }
`;
export const PasteImgModalOverlay = styled.div`
  background: rgba(1, 1, 1, 0.6);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
`;

export const PasteImgModalContainer = styled.div`
  background: var(--white);
  width: 100%;
  height: 75vh;
  max-width: 900px;
  border-radius: 4px;
  box-shadow: 0 0 60px rgba(0, 0, 0, 0.05);
  text-align: center;
  position: relative;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 100px;
`;
export const HeaderModal = styled.header`
  background-color: #3d9be9;
  width: 100%;
  height: 64px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem;
`;

export const TitleModal = styled.h6`
  font-size: 1.25rem;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 500;
  line-height: 1.6;
  letter-spacing: 0.0075em;
  color: #fff;
`;

export const IconBtn = styled(IconButton)``;

export const CloseModal = styled(Close)`
  fill: white;
`;

export const ImageContent = styled.img`
  width: 540px;
  height: 440px;
  object-fit: contain;
`;

export const SendBtn = styled(Button)`
  height: 50px;
  width: 180px;
  border-radius: 12px;
`;

export const MessagesContainer = styled.div``;

export const MessagesHeader = styled.div``;

export const MessagesLoading = styled(CircularProgress)`
  position: absolute;
  left: 50%;
  top: 2%;
  background: #fff;
  padding: 4px;
  border-radius: 50%;
  z-index: 10;
`;

export const Sentinel = styled.div`
  height: 40px;
`;

export const MessagesSentinel = styled.div`
  height: 60px;
`;

export const MessagesFooter = styled.div`
  height: 12px;
`;

export const Clock = styled(BiTime)`
  font-size: 12px;
  margin-left: 5px;
`;

